import MediaLibrarySearchLink from './media-library/search-link';
import { fetchSnippetsForProductNumberList, prepareSnippetsForDOMInsertion } from './product-snippets';
import { initClickTracking } from './click-tracking';

jQuery(function($)
{
    var
        $body = $('body'),
        containerSelector = '#product-buy-box, .product-buy-box-list, .product-buy-box-tiles, '
			+ '#product-variation-list, .directorder-product-buy-box, .js-basket-recommendation',
        variationContainerSelectorSelect = '.variation-container .js-tilesview-variation-select',
        formSelector = containerSelector + ', .buy-form, .item-container, .js-crossselling-buy--button',
        triggerToCartSelector = 'button.toCart',
        triggerProductCheckboxSelector = '.js-product-list-item .choise input',
        triggerProductQuantitySelector = '.js-product-list-item input[name=quantity]',
        sellingUnitToBuyBoxButtonSelector = '#sellingUnitToBuyBox',
        api = orion.api.cart.orderitems,
        lastChosenProduct = null,
        language = $('html').attr('lang');

    function handleTriggerToCart(e)
    {
        e.preventDefault();
        var
            $form =  $($(this).closest(formSelector)),
            $field = $($(this).closest('.js-product-list-item, .js-basket-recommendation, #buy')
                .find('input[name=quantity]')),
            quantity = parseInt($field.val(), 10),
            productItems = [];

        if (quantity == 0)
        {
            quantity = 1;
        }

        productItems.push({
            'productNumber': $field.attr('data-product-number'),
            'quantity': quantity
        });

        $field.val(1);

        if (productItems.length === 0)
        {
            var feedbackMsg = $('#feedback-to-cart-failed').text();

            $body.append(
                '<div class="feedback error js-feedback">'
				+ '<i class="fa-regular fa-exclamation-circle"></i><p>'
				+ feedbackMsg + '</p><a href="#" class="close"><i class="fa-regular fa-times"></i></a></div>'
            );
            $body.trigger('feedback-added');
            return;
        }

        if (!$(this).hasClass('completed') && !$(this).hasClass('loading'))
        {
            var $feedbackContainer = $('<span></span>');

            $feedbackContainer.addClass('feedback-container');

            $body.removeClass(orion.constants.ClassBasketUpdated);
            $(this).removeClass('completed')
                .addClass('loading');

            $(this).prepend($feedbackContainer);

            api.add({ productItems: productItems }).done(function()
            {
                $form.trigger(orion.constants.EventCartProductCreated, productItems[0]);
                $body.trigger(orion.constants.EventCartProductCreated, productItems[0]);
            })
                .always(function()
                {
                    $body.removeClass(orion.constants.ClassProcessing);
                    $(this).removeClass('loading')
                        .addClass('completed');

                    setTimeout(function()
                    {
                        $(this).find('.feedback-container')
                            .remove();
                        $(this).removeClass('completed');
                    }.bind(this), 1500);
                }.bind(this));
        }
    }

    function handleSellingUnitToBuyBoxSubmit(e)
    {
        e.preventDefault();

        let sellingUnit = parseInt($(this).data('selling-unit-value'));

        let quantity = parseInt($('input[name=quantity]', '#product-buy-box').val());

        let value = sellingUnit - (quantity % sellingUnit) + quantity;

        $('input[name=quantity]', '#product-buy-box').val(value).trigger('change');
    }

    function handleTriggerProductCheckbox(e)
    {
        if ($(e.target).prop('checked'))
        {
            var $quantity = $('input[name=quantity]', $(e.target).closest('.js-product-list-item'));

            if ($quantity.val() <= 0)
            {
                $quantity.val(1);

                $quantity.trigger('change');
            }
        }
    }

    function handleTriggerProductQuantity(e)
    {
        var $checkbox = $('.choise input', $(e.target).closest('.js-product-list-item'));

        if ($(e.target).val() > 0 && !$checkbox.prop('checked'))
        {
            $checkbox.click();
        }
        else if ($(e.target).val() <= 0 && $checkbox.prop('checked'))
        {
            $checkbox.click();
        }
    }

    function markWrongQuantityInput(e)
    {
        var $value = $(e.target).val();
        var regEx = /^0*?[1-9]\d*$/g;

        if (!regEx.test($value))
        {
            $(e.target).closest('.js-product-quantity')
                .addClass('error');
        }
        else if ($value)
        {
            $(e.target).closest('.js-product-quantity')
                .removeClass('error');
        }
    }

    function fetchProduct(loadingIndicator, imageWrapper, productNumber)
    {
        var apiUrl = '/api-product-' + language + '/' + productNumber;

        return fetch(apiUrl)
            .then(function(response)
            {
                if (response.status !== 200)
                {
                    indicateProductVariationChangeFinished(loadingIndicator, imageWrapper);
                    return;
                }

                return response.json();
            })
            .catch(function()
            {
                indicateProductVariationChangeFinished(loadingIndicator, imageWrapper);
            });
    }

    function updateProductData(item, json)
    {
        updateProductImageData(item, json);
        updateProductPriceData(item, json);
        updateProductAvailabilityData(item, json);
        item.setAttribute('data-product-number', json.productNumber);
        item.querySelector('.image-container a').href = json.productUrl;
        item.querySelector('.sku').innerHTML = json.productNumber;
        lastChosenProduct = json.productNumber;
    }

    function updateProductImageData(item, json)
    {
        var image = item.querySelector('.image-container img');

        image.src = json.image;
    }

    function updateProductPriceData(item, json)
    {
        if (json.price.showEndPrice === true)
        {
            var endPrice = item.querySelector('.price .p4');
            var retailPrice = item.querySelector('.price.p7.srp');

            endPrice.innerHTML = json.price.endPrice;
            retailPrice.innerHTML = json.price.prefix + ' ' + json.price.suggestedRetailPrice;
        }
        else
        {
            var price = item.querySelector('.price .p5');
            var prefix = item.querySelector('.price .pre');

            price.innerHTML = json.price.suggestedRetailPrice;
            prefix.innerHTML = json.price.prefix;
        }
    }

    function updateProductAvailabilityData(item, json)
    {
        var availability = item.querySelector('.availability');

        availability.classList.remove('in-stock');
        availability.classList.remove('out-of-stock');

        switch (json.availability)
        {
        case 1:
            availability.classList.add('in-stock');
            break;
        case 2:
            availability.classList.add('out-of-stock');
            break;
        case 3:
            availability.classList.add('out-of-stock');
        }
    }

    function indicateProductVariationChangeFinished(loadingIndicator, imageWrapper)
    {
        loadingIndicator.classList.add('loading-indicator--hidden');
        imageWrapper.style.display = 'block';
    }

    function reactOnFetchProduct(json)
    {
        if (lastChosenProduct === null)
        {
            return;
        }

        var item = document.querySelector('.sortiment.item[data-product-number="' + lastChosenProduct + '"]');

        if (item === null)
        {
            return;
        }

        updateProductData(item, json);
    }

    function indicateProductVariationChangeInProgress(loadingIndicator, imageWrapper)
    {
        loadingIndicator.classList.remove('loading-indicator--hidden');
        imageWrapper.style.display = 'none';
    }

    function changeVariation(e)
    {
        var oldItem = document.querySelector('.sortiment.item[data-product-number="' + lastChosenProduct + '"]');

        if (oldItem === null)
        {
            return;
        }

        var loadingIndicator = oldItem.querySelector('.loading-indicator');
        var imageWrapper = oldItem.querySelector('.image-wrapper');

        indicateProductVariationChangeInProgress(loadingIndicator, imageWrapper);

        fetchProduct(loadingIndicator, imageWrapper, e.target.value, oldItem)
            .then(function(json)
            {
                indicateProductVariationChangeFinished(loadingIndicator, imageWrapper);
                reactOnFetchProduct(json);
            })
            .catch(function()
            {
                indicateProductVariationChangeFinished(loadingIndicator, imageWrapper);
            });
    }

    function noticeVariationChange(e)
    {
        lastChosenProduct = $(e.target).value;
    }

    function handlePromotionTags(promotionTagElement)
    {
        let promotionProductNumbers = promotionTagElement.getAttribute('data-product-number-list');
        let currentProductNumber;

        let productBuyBox = document.querySelector('#product-buy-box');

        if (productBuyBox)
        {
            currentProductNumber = productBuyBox
                .querySelector('.js-quantity-product-buy-box')
                .getAttribute('data-product-number');
        }

        let productListItem = promotionTagElement.closest('.js-product-list-item');

        if (productListItem)
        {
            currentProductNumber = productListItem.getAttribute('data-product-number');
        }

        if (currentProductNumber && !promotionProductNumbers.includes(currentProductNumber))
        {
            promotionTagElement.classList.add('hidden');
        }
    }

    $body
        .on('click', sellingUnitToBuyBoxButtonSelector, handleSellingUnitToBuyBoxSubmit)
        .on('click', triggerToCartSelector, handleTriggerToCart)
        .on('click', triggerProductCheckboxSelector, handleTriggerProductCheckbox)
        .on('change', triggerProductQuantitySelector, handleTriggerProductQuantity)
        .on('keyup change', triggerProductQuantitySelector, markWrongQuantityInput);
    var $variationContainerSelector = $(variationContainerSelectorSelect);

    if ($variationContainerSelector)
    {
        $variationContainerSelector.on('change', changeVariation);

        $variationContainerSelector.on('focus', function(e)
        {
            noticeVariationChange(e);
        });
    }

    let promotionTagElements = document.querySelectorAll('.js-promotion-tag');

    promotionTagElements.forEach(promotionTagElement => handlePromotionTags(promotionTagElement));

    // etracker datalayer enrichment
    function pushBasketRecommendationToDataLayer(event)
    {
        let target = event.target.closest('.js-gtm-basket-recommendation-buy-button');
        let input = target.parentElement.querySelector('.js-product-quantity input');
        let productNumber = parseInt(input.dataset.productNumber);
        let productName = input.dataset.productTitle;
        let productPrice = parseFloat(parseFloat(input.dataset.productPrice.replace(',', '.')).toFixed(2));
        let quantity = parseInt(input.value);

        window.dataLayer.push({
            event: 'productToCartClick',
            productInformation: {
                number: productNumber,
                name: productName,
                price: productPrice,
                quantity: quantity,
            }
        });
    }

    document.querySelectorAll('.js-gtm-basket-recommendation-buy-button').forEach(basketRecommendation =>
    {
        basketRecommendation.addEventListener('click', pushBasketRecommendationToDataLayer);
    });
});

jQuery(function($)
{
    var $container = $('#product');

    if ($container.length === 0)
    {
        return;
    }

    const defaultProductNumber = document.querySelector('input[name=defaultProductNumber]').value;

    // PDS novelties slider: Fetch, process and insert snippets into container element
    const section = document.querySelector('.js-crossselling__novelties--section');
    const container = document.querySelector('.js-crossselling__novelties--slider');
    const { labelName } = container.dataset;

    fetchLabelNoveltiesProductNumberList(labelName).then(response => response.json()).then(productNumberList =>
    {
        if (productNumberList.length)
        {
            fetchSnippetsForProductNumberList(productNumberList, 10).then(response => response.json()).then(snippets =>
            {
                snippets[0].snippets.forEach(snippet =>
                {
                    const element = prepareSnippetsForDOMInsertion(snippet, '');

                    container.appendChild(element);
                });

                initSlider(container);

                section.classList.remove('hidden');

                // Workaround to queue the trigger and init into the next event loop
                // to execute it AFTER every script inside the snippets is finished
                setTimeout(() => $('#content').trigger(orion.constants.EventProductListReloaded), 0);
            });
        }
    });

    function buildProductExcludeFilterQuery()
    {
        const productVariationsProductNumberList = [];

        const productMain = document.querySelector('.js-product-variation__main-product');
        const productVariations = document.querySelectorAll('.js-product-variation');

        if (productVariations.length)
        {
            productVariations.forEach(variation =>
            {
                productVariationsProductNumberList.push(variation.dataset.productNumber);
            });
        }
        else
        {
            productVariationsProductNumberList.push(productMain.dataset.productNumber);
        }

        return `&fq_exclude=-productNumber:(${productVariationsProductNumberList.map(productNumber =>
            `"${productNumber}"`).join(' OR ')})`;
    }

    function fetchLabelNoveltiesProductNumberList(labelName)
    {
        const productExcludeFilterQuery = buildProductExcludeFilterQuery();

        return fetch(
            '/api-product-search?q=labelNameFacet:"' + labelName + '"&sort=sortByNoveltyTimestamp desc&rows=10'
                + '&fq_collapse={!tag=collapse}{!collapse field=solrProductGroupId_DE sort=\'score desc\'}'
                + productExcludeFilterQuery
        );
    }

    /*    // ++++ Konfigurationen der Slider ++++ // */
    let cosssellingSliderContainer = document.querySelector('.js-crossselling-slider');

    if (cosssellingSliderContainer)
    {
        document.querySelectorAll('.js-crossselling-slider').forEach(slider =>
        {
            initSlider(slider);
        });
    }

    function initSlider(slider)
    {
        tns({
            container: slider,
            items: 2,
            speed: 300,
            controlsText: ['', ''],
            nav: false,
            loop: false,
            responsive: {
                768: {
                    items: 3
                },
                1150: {
                    items: 4
                },
                1400: {
                    items: 5
                }
            }
        });
    }

    const mlSearchLinkElement = document.querySelector('.js-media-library__search-link');

    (new MediaLibrarySearchLink).init(mlSearchLinkElement);

    function updateProductHistory(productNumber)
    {
        const productHistoryKey = 'recentlyViewedProducts';

        let productHistoryData = JSON.parse(localStorage.getItem(productHistoryKey)) || [];

        productHistoryData = productHistoryData.filter(num => num !== productNumber);

        productHistoryData.push(productNumber);

        if (productHistoryData.length > 20)
        {
            productHistoryData = productHistoryData.slice(productHistoryData.length - 20);
        }

        localStorage.setItem(productHistoryKey, JSON.stringify(productHistoryData));
    }

    updateProductHistory(defaultProductNumber);

    initClickTracking();
});
